import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { ImplementDetailsService } from '../../implement-details/implement-details.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-new-implement-and-buildno',
  templateUrl: './add-new-implement-and-buildno.component.html',
  styleUrls: ['./add-new-implement-and-buildno.component.scss']
})
export class AddNewImplementAndBuildnoComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AddNewImplementAndBuildnoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _implementService: ImplementDetailsService,
    private toastr: NotificationsService, ) { }

  
    modelName:string;
    selectImplementTypeId:number=0

  ngOnInit() {
    this.selectImplementTypeId=this.data.selectImplementTypeId
   
  }
  DialogClose(){
    this.dialogRef.close(false)
  }

  checkBuiltNo(event) {
    console.log(event.target.value)
    if(event.target.value !=""){
      this._implementService.VerifyBuiltaNo(event.target.value).subscribe(res => {

        if (res == false) {
          this.toastr.error('Operation failed!', 'That Build # already exists! Please enter a valid Build #');
        }
        else {
          this.toastr.success('Build # validated');
        }
  
      })
    }

  }


  AddBuiltNo()
  {
    if(this.modelName !="" && this.selectImplementTypeId!=0 ){
      this._implementService.addNewGETImplementBuiltNo(this.modelName, this.selectImplementTypeId).subscribe(res=>{
        console.log(res);
  
        this.dialogRef.close(res)
  
      })
    }
 else{
  this.toastr.error('Please Enter Implement Type');
 }
  }
}
